/* global angular, moment, Audio */
/**
 * Created by lari on 03/05/2017.
 */

(function () {
  'use strict';
  angular.module('vcchat')
    .component('chat', {
      restrict: 'E',
      template: `
        <div class="panel panel-default">
          <div class="panel-heading">Nachrichten</div>
          <div class="panel-body">
            <div scroll-glue class="chatlog">
              <div ng-repeat="msg in vm.chatlog track by $index">
                <div ng-bind="msg"></div>
              </div>
            </div>
        
            <form>
              <div class="input-group">
                <input class="form-control"
                       ng-model="vm.newmessage" id="newgroup" placeholder="Nachricht eingeben" />
                <span class="input-group-btn">
                  <button class="btn btn-success"
                          type="submit"
                          ng-click="vm.sendMsg()"><i class="fa fa-send"></i></button>
                </span>
              </div>
            </form>
          </div>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Rlog', '$cookies', 'vertxEventBusService',
        function ($log, Rlog, $cookies, vertxEventBusService) {
          let vm = this;
          vm.sendMsg = sendMsg;


          vm.$onInit = function () {
            vm.chatlog = [];
          };

          function sendMsg() {
            let msg = $cookies.get('username') + ': ' + vm.newmessage;
            vertxEventBusService.publish('chat.to.server', msg);
            vm.newmessage = '';
          }

          const chatHandler = function (message) {
            let audio = new Audio('img/submarine.wav');
            audio.play();
            // $log.debug('Received a message: ', message);

            vm.chatlog.push(message);
          };

          vertxEventBusService.on('chat.to.client', {}, chatHandler);

          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('chat.to.client', {}, chatHandler);
          };


        }] // controller
    }); // component

  // klammerfriedhof
}());
